import { render, staticRenderFns } from "./GlobalFooter.vue?vue&type=template&id=01a1fd63&scoped=true&"
import script from "./GlobalFooter.vue?vue&type=script&lang=js&"
export * from "./GlobalFooter.vue?vue&type=script&lang=js&"
import style0 from "./GlobalFooter.vue?vue&type=style&index=0&id=01a1fd63&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a1fd63",
  null
  
)

component.options.__file = "GlobalFooter.vue"
export default component.exports